import { getCopilotChatDrawerState } from '../store/store';

export function isEmptyReadingPaneFillDisabled(targetWindow: Window): boolean {
    return getCopilotChatDrawerState(targetWindow)?.disableEmptyReadingPaneFill ?? false;
}
